import Model, { attr, belongsTo } from '@ember-data/model';
import { computed } from '@ember/object';

export default class ComPaisModel extends Model {
  @attr('string') codpais;

  @attr('string') codIso;

  @attr('string') nompais;

  @computed('codpais', 'nompais')
  get codigoNombre() {
    return `${this.codpais} - ${this.nompais}`;
  }
}
